<template>
  <!-- exhibition-product .ep -->
  <div class="ecb">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>我的云店</BreadcrumbItem>
          <BreadcrumbItem>上传产品</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
        <p class="header-tool-text" style="font-weight:bold;color:#b10042;">重要提示：此部分产品信息将于中国国际焙烤展移动端小程序与PC端同步显示，供观众查询使用</p> 
        <Input
          search
          placeholder="请输入关键字"
          v-model="searchField"
          @on-search="searchPro()"
          v-if="String(showTabs) === '1'"
          style="width:230px;margin-top:20px;"
        /> 
      </div>
      <div v-show="String(showTabs) === '1'" class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/index/product/addpro?num=' + proNum)">
          <span class="htb-add">+</span>
          <span>添加产品</span>
        </div>
        <!-- <Button :disabled="exportList && exportList.items && exportList.items.length?false:true" @click="exportData()">批量导出</Button> -->
      </div>
      <!-- <div v-show="String(showTabs) === '3'" class="header-tool-box">
        <div class="htb-item" @click="downloadList()">
          <span class="htb-add">+</span>
          <span>名单下载</span>
        </div>
      </div> -->
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="产品" name="1">
          <exhibitionProductItem
            ref="exhibitionProductItem"
            v-if="String(showTabs) === '1'"
            :searchField="searchField"
            @numChange="numChange"
            @dataChange="dataChange"
          />
        </TabPane>
        <TabPane label="留言" name="2">
          <exhibitionProductMes ref="exhibitionProductMes" v-if="String(showTabs) === '2'" />
        </TabPane>
        <!-- <TabPane label="试用申请" name="3">
          <exhibitionProductApply ref="exhibitionProductApply" v-if="String(showTabs) === '3'" />
        </TabPane> -->
      </Tabs>
    </div>

    <!-- 编辑产品 -->
    <!-- <product-edit
        :formData="current"
        :showed="editFlag"
        title="编辑产品"
        @form-submit="editProduct"
        @close="editFlag=false;"
        ref="productEdit"
    ></product-edit>-->
    <Contact />
  </div>
</template>

<script>
// import productEdit from "./../../components/product-edit.vue";
import exhibitionProductItem from "./../../subpages/exhibition-product-item/exhibition-product-item.vue";
import exhibitionProductMes from "./../../subpages/exhibition-product-mes/exhibition-product-mes.vue";
import exhibitionProductApply from "./../../subpages/exhibition-product-apply/exhibition-product-apply.vue";

import Contact from "@components/Contact/Contact";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "exhibition-business",
  data() {
    return {
      addBrandflag: false,
      showTabs: "1",
      searchField: "", // 搜索关键字
      proNum: 0,
      
      exportList: []
    };
  },
  components: {
    // productEdit,
    exhibitionProductItem,
    exhibitionProductMes,
    exhibitionProductApply,
    Contact
  },
  created() {
    this.changeTab();
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      list: "productModule/list",
      pageInfo: "productModule/pageInfo",
      current: "productModule/current",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$route.query;
    }
  },
  methods: {
    ...mapMutations({
      refushPageInfo: "productModule/refushPageInfo",
      refushWheres: "productModule/refushWheres",
      refushCurrent: "productModule/refushCurrent"
    }),
    ...mapActions({
      getList: "productModule/getList",
      addProduct: "productModule/addProduct",
      add: "productModule/add",
      edit: "productModule/edit",
      getOne: "productModule/getOne",
      remove: "productModule/remove"
    }),
    numChange(e) {
      this.proNum = e;
    },
    dataChange(e) {
      this.exportList = e;
    },
    searchPro() {
      this.$refs.exhibitionProductItem.init();
    },
    changeTab() {
      if (this.query && this.query.type && this.query.type === "all") {
        this.showTabs = "1";
        // this.flag = false;
      } else if (this.query && this.query.type && this.query.type === "mes") {
        this.showTabs = "2";
      } else if (this.query && this.query.type && this.query.type === "apply") {
        this.showTabs = "3";
      }
    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=all`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=mes`);
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=apply`);
      }
    },
    downloadList() {
      this.$refs.exhibitionProductApply.exportInfo();
    },
    // cancel(name) {
    //   this.$refs[name].handleReset();
    // },
    // async editShow(id) {
    //   this.editFlag = true;
    //   await this.getOne({ data: { id: id } });
    // },
    exportData(name) {
      let tHeader = ["公司名称", "产品名称", "产品一级分类", "产品二级分类","产品三级分类","产品四级分类","招商区域","产品标签","产品适用渠道","应用科室"];
      this.exportList.items.map(c => {
        if (c.authentication) {
          c.authentication = JSON.parse(c.authentication);
        }
      })
      console.log(111,this.exportList.items);
    },
    // setNume(num) {
    //   this.num = num;
    // },
    // async editProduct(form) {
    //   let req = {
    //     Id: form.id,
    //     SetValues: {
    //       Name: form.Name,
    //       Banner: form.Banner,
    //       StyleId: form.StyleId,
    //       Introduction: form.Introduction,
    //       IsApply: form.IsApply,
    //       ApplyMaxCount: form.ApplyMaxCount,
    //       ApplyStart: form.ApplyStart,
    //       ApplyEnd: form.ApplyEnd,
    //       Video: form.Video
    //     }
    //   };
    //   this.edit({
    //     data: req
    //   }).then(re => {
    //     this.editFlag = false;
    //     this.$Message.success("操作成功！");
    //     this.reload();
    //     this.$refs["productEdit"].handleReset();
    //   });
    // },
    // reload() {
    //   if (String(this.showTabs) === "1") {
    //     this.$refs["exhibitionProductItem"].init();
    //   } else if (String(this.showTabs) === "2") {
    //     this.$refs["exhibitionProductMes"].init();
    //   } else if (String(this.showTabs) === '3') {
    //     this.$refs["exhibitionProductApply"].init();
    //   }
    // },
  }
};
</script>

<style scoped lang="scss">
.eb-top-r {
  height: 100%;
  display: flex;
  align-items: flex-end;
  padding-bottom: 15px;
  &-box {
    width: 148px;
    height: 78px;
    border: 1px dashed #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      border: 1px dashed #1890ff;
      transition: 0.5s;
    }
    .I1 {
      font-size: 16px;
      font-weight: bold;
      color: #1890ff;
    }
    .s3 {
      font-size: 14px;
      color: #1890ff;
      margin-left: 9px;
    }
  }
}
</style>
